<template>
  <Transition
    enter-active-class="transition-opacity duration-200 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-if="visible" class="fixed inset-x-0 bottom-0 z-[120] p-3 md:p-4">
      <div class="mx-auto max-w-screen-lg rounded-xl border border-slate-200 bg-white shadow-lg">
        <div class="p-3 md:p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div class="text-sm text-slate-700">
            <div class="font-semibold text-slate-800 mb-1">Çerez Kullanımı</div>
            <div>
              Site deneyimini iyileştirmek, ziyaretleri analiz etmek ve reklam dönüşümlerini ölçmek için isteğe bağlı çerezler kullanıyoruz.
              Tercihinizi istediğiniz zaman değiştirebilirsiniz.
            </div>
            <a href="/page/privacy" target="_blank" class="inline-block mt-1 text-xs text-sky-700 hover:text-sky-800 underline">
              Çerez ve Gizlilik Politikası
            </a>
          </div>

          <div class="flex items-center gap-2 shrink-0">
            <button
              type="button"
              class="px-3 py-2 rounded-md border border-slate-300 text-slate-700 hover:bg-slate-100 text-sm font-semibold"
              @click="rejectCookies"
            >
              Reddet
            </button>
            <button
              type="button"
              class="px-3 py-2 rounded-md bg-sky-700 text-white hover:bg-sky-800 text-sm font-semibold"
              @click="acceptCookies"
            >
              Kabul Et
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <button
    v-if="!visible && consentCookie"
    type="button"
    class="fixed bottom-3 left-3 z-[110] rounded-full border border-slate-300 bg-white px-3 py-2 text-xs font-semibold text-slate-700 shadow-md hover:bg-slate-50"
    @click="visible = true"
  >
    Çerez tercihleri
  </button>
</template>

<script setup>
import { nextTick, ref, onMounted } from 'vue'

const consentCookie = useCookie('cookie_consent', {
  path: '/',
  sameSite: 'lax',
  maxAge: 60 * 60 * 24 * 180
})

const visible = ref(false)

const notifyConsent = (value) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: value }))
  }
}

const clearAnalyticsCookies = () => {
  if (typeof document === 'undefined') return
  const analyticsCookie = /^(_ga|_gid|_gat|_gcl_)/
  const hostname = window.location.hostname.replace(/^www\./, '')

  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0]?.trim()
    if (!name || !analyticsCookie.test(name)) return
    const expired = `${name}=; Max-Age=0; path=/; SameSite=Lax`
    document.cookie = expired
    document.cookie = `${expired}; domain=.${hostname}`
  })
}

const acceptCookies = async () => {
  consentCookie.value = 'accepted'
  visible.value = false
  await nextTick()
  notifyConsent('accepted')
}

const rejectCookies = async () => {
  consentCookie.value = 'rejected'
  clearAnalyticsCookies()
  visible.value = false
  await nextTick()
  notifyConsent('rejected')
}

onMounted(() => {
  visible.value = !consentCookie.value
})
</script>
